import React from 'react';

import { Badge, BadgeProps } from '@mantine/core';
import { Invoice } from 'types';

export const statusColorMap: Record<Invoice['status'], { label: string; color: BadgeProps['color'] }> = {
  UPCOMING: {
    label: 'UPCOMING',
    color: 'kiloBlue',
  },
  PENDING: {
    label: 'PENDING',
    color: 'green',
  },
  PAID: {
    label: 'PAID',
    color: 'green',
  },
  'PAST DUE': {
    label: 'PAST DUE',
    color: 'red',
  },
  'PAYMENT FAILED': {
    label: 'PAYMENT FAILED',
    color: 'red',
  },
  'FAILED PAST DUE': {
    label: 'FAILED PAST DUE',
    color: 'red',
  },
  'REFUND PENDING': {
    label: 'REFUND PENDING',
    color: 'orange',
  },
  REFUNDED: {
    label: 'REFUNDED',
    color: 'orange',
  },
  'PARTIALLY REFUNDED': {
    label: 'PARTIALLY REFUNDED',
    color: 'orange',
  },
  VOID: {
    label: 'VOID',
    color: 'gray',
  },
};
type InvoiceStatusBadgeProps = BadgeProps & {
  status: Invoice['status'];
};

const InvoiceStatusBadge = ({
  status,
  variant = 'filled',
  fullWidth = true,
  size = 'xs',
  ...props
}: InvoiceStatusBadgeProps): JSX.Element => {
  const { label, color } = statusColorMap[status] || { label: 'UNKNOWN', color: 'gray' };
  return (
    <Badge color={color} variant={variant} fullWidth={fullWidth} size={size} {...props}>
      {label}
    </Badge>
  );
};

export default InvoiceStatusBadge;
